import { mapActions, mapMutations } from 'vuex'

import { cpf } from 'cpf-cnpj-validator'
import { strip as cnpjStrip } from '@/utils/validators/cnpj'

import { StatusAgendamento } from '@/utils/agendamento'

import { RELATORIO_CANCELADOS } from '@/utils/storages'

const LOCAL_STORAGE_ID = RELATORIO_CANCELADOS

export const methods = {
  ...mapActions('fornecedores', ['getFornecedores']),
  ...mapActions('clientes', ['getClientes']),
  ...mapActions('transportadoras', ['getTransportadoras']),
  ...mapActions('contratos', ['getContratos']),
  ...mapActions('patio', ['getRegioes', 'getRepresentantes']),
  ...mapActions('motoristas', ['getMotoristas']),
  ...mapMutations('params', ['UPDATE_PARAMS']),

  handleFixParams(fixedParams, [key, param]) {
    if (param.value) {
      const paramsWithCNPJ = [
        'fornecedor',
        'terminal',
        'cliente',
        'transportadora',
      ]
      const paramsWithCPF = ['representante', 'motorista']

      if (param.until == true) {
        if (param.value.trim().split(' ').length == 1) {
          param.value += ' 23:59:59'
        } else if (param.value.trim().split(' ')[1].split(':').length == 2) {
          param.value += ':59'
        }
      }

      if (paramsWithCNPJ.includes(key))
        fixedParams[key] = cnpjStrip(param.value)
      else if (paramsWithCPF.includes(key))
        fixedParams[key] = cpf.strip(param.value)
      else fixedParams[key] = param.value
    }

    return fixedParams
  },
  fixParams() {
    return Object.entries(this.params).reduce(
      this.handleFixParams,
      new Object()
    )
  },
  addParamsFilter() {
    localStorage.setItem(LOCAL_STORAGE_ID.details, JSON.stringify(this.params))
  },

  getParamsFilter() {
    if (localStorage.getItem(LOCAL_STORAGE_ID.details)) {
      const params_local = JSON.parse(
        localStorage.getItem(LOCAL_STORAGE_ID.details)
      )
      Object.entries(params_local).forEach((item) => {
        if (item[0] in this.params)
          this.params[item[0]] = { ...this.params[item[0]], ...item[1] }
      })
    }
  },

  search() {
    if (!this.areSettingsEmpty) {
      const fixedParams = {
        ...this.fixParams(),
        status: StatusAgendamento.CANCELADO,
      }
      this.UPDATE_PARAMS({ key: LOCAL_STORAGE_ID.storage, params: fixedParams })
      this.$emit('search')
    }
  },

  async showOnlySelectedOptionsAndGetItems() {
    if (localStorage.getItem(LOCAL_STORAGE_ID.details)) {
      const params_local = JSON.parse(
        localStorage.getItem(LOCAL_STORAGE_ID.details)
      )
      Object.entries(params_local).forEach((item) => {
        if (item[0] in this.params)
          this.params[item[0]] = { ...this.params[item[0]], ...item[1] }
      })
    }
    this.allOptions.forEach((someOption) => {
      if (this.params[someOption]) {
        this.params[someOption].visible = false
      } else {
        console.log(someOption + ' não encontrada!')
      }
    })
    this.selectedOptions.forEach((option) => {
      if (this.params[option]) {
        this.params[option].visible = true
      } else {
        console.log(option + ' não encontrada!')
      }
      //this.params[option].visible = true
    })
    this.allOptions.forEach((someOption) => {
      if (this.params[someOption]?.visible == false) {
        this.params[someOption].value = ''
      }
    })
    this.addParamsFilter()
    this.showDaddy()
  },

  showDaddy() {
    for (let [daddy, dependents] of Object.entries(this.dependents)) {
      const isSomeDependentVisible = dependents.some(
        (dependent) => this.params[dependent].visible
      )
      if (isSomeDependentVisible) {
        this.params[daddy].visible = true
      }
    }
  },
}
